/* HAFEZ · HafezOrient — theme.js · Vanilla: Sticky-Header, Scroll-Reveal, Swipe-Galerie */
(function () {
  'use strict';

  var prefersReduced = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Sticky / Shrink Navigation */
  var nav = document.querySelector('.nav');
  if (nav) {
    var onScroll = function () {
      if (window.pageYOffset > 24) { nav.classList.add('scrolled'); }
      else { nav.classList.remove('scrolled'); }
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Smooth scroll für Anker-Links */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var id = this.getAttribute('href');
      if (id.length < 2) return;
      var target = document.querySelector(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });
      }
    });
  });

  /* Aktiver Nav-Link */
  (function () {
    var current = window.location.pathname.split('/').pop() || 'index.html';
    document.querySelectorAll('.nav-link').forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href) return;
      if (href === current || (current === '' && href === 'index.html')) {
        link.classList.add('active');
      }
    });
  })();

  /* Scroll-Reveal */
  function initReveal() {
    var targets = document.querySelectorAll(
      '.product-card, .collection-card, .collection-card-large, .about-grid, ' +
      '.value-item, .info-card, .section-header, .page-header, .appointment-section, ' +
      '.contact-item'
    );
    if (!targets.length) return;
    if (prefersReduced || !('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('reveal', 'is-visible'); });
      return;
    }
    targets.forEach(function (el, i) {
      el.classList.add('reveal');
      el.style.transitionDelay = (Math.min(i % 6, 5) * 60) + 'ms';
    });
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    targets.forEach(function (el) { observer.observe(el); });
  }

  /* Produkt-Galerie: Swipe-Slideshow */
  function initGalleries() {
    var galleries = document.querySelectorAll('[data-product-gallery]');
    galleries.forEach(function (gallery) {
      var track = gallery.querySelector('[data-gallery-track]');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.querySelectorAll('[data-gallery-slide]'));
      if (slides.length <= 1) return;

      var prevBtn = gallery.querySelector('[data-gallery-prev]');
      var nextBtn = gallery.querySelector('[data-gallery-next]');
      var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-dot]'));

      var current = -1;

      function goTo(index) {
        index = Math.max(0, Math.min(index, slides.length - 1));
        var slide = slides[index];
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: prefersReduced ? 'auto' : 'smooth' });
      }

      function updateControls(index) {
        dots.forEach(function (dot, i) {
          var on = i === index;
          dot.classList.toggle('is-active', on);
          dot.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        if (prevBtn) prevBtn.disabled = index === 0;
        if (nextBtn) nextBtn.disabled = index === slides.length - 1;
      }

      function setActive(index) {
        if (index === current) return;
        current = index;
        updateControls(index);
      }

      if (prevBtn) { prevBtn.addEventListener('click', function () { goTo(current - 1); }); }
      if (nextBtn) { nextBtn.addEventListener('click', function () { goTo(current + 1); }); }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () { goTo(i); });
      });

      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
        else if (e.key === 'Home') { e.preventDefault(); goTo(0); }
        else if (e.key === 'End') { e.preventDefault(); goTo(slides.length - 1); }
      });

      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = window.requestAnimationFrame(function () {
          raf = null;
          var width = track.clientWidth || 1;
          var index = Math.round(track.scrollLeft / width);
          index = Math.max(0, Math.min(index, slides.length - 1));
          setActive(index);
        });
      }, { passive: true });

      setActive(0);
    });
  }

  function boot() { initReveal(); initGalleries(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
